export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";